import { Star, Phone, Navigation, Globe } from "lucide-react";

/**
 * Premium coded "Google Business Profile + reviews" mockup: a dark-themed GBP card
 * with rating, action chips, and live 5-star reviews streaming in. Used in the WebSeo
 * layers sidebar (the "GBP + Reviews on autopilot" build) so the page isn't showing
 * two near-identical map packs. Dark variant to sit in the slate layers section.
 */
const reviews = [
  { initials: "DM", name: "Dave M.", text: "Showed up same day and fixed it fast. Booked right through their site." },
  { initials: "KL", name: "Karen L.", text: "Easiest quote I've ever gotten. Highly recommend." },
];

export const ReviewsMockup = () => {
  return (
    <div className="relative w-full max-w-[420px] mx-auto select-none">
      {/* floating badge */}
      <div className="absolute -top-3 right-4 z-10 rounded-full bg-gradient-to-br from-blue-600 to-violet-600 px-3.5 py-1.5 text-xs font-bold text-white shadow-lg shadow-blue-900/30">
        Reviews on autopilot
      </div>

      <div className="overflow-hidden rounded-2xl border border-slate-700 bg-slate-900/80 shadow-2xl backdrop-blur-sm">
        {/* GBP header */}
        <div className="border-b border-slate-700 px-5 py-4">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="truncate text-base font-bold text-white">Northern Plumbing &amp; Heating</p>
              <p className="mt-0.5 text-xs text-slate-400">Plumber &middot; Thunder Bay</p>
            </div>
            <span className="shrink-0 rounded-full bg-emerald-500/15 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-emerald-400">
              Open
            </span>
          </div>
          <div className="mt-2.5 flex items-center gap-2">
            <span className="text-lg font-bold text-white">4.9</span>
            <div className="flex items-center gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-xs text-slate-400">127 reviews</span>
          </div>
        </div>

        {/* action chips */}
        <div className="flex items-center gap-2 border-b border-slate-800 px-5 py-3">
          {[
            { icon: Phone, label: "Call" },
            { icon: Navigation, label: "Directions" },
            { icon: Globe, label: "Website" },
          ].map(({ icon: Icon, label }) => (
            <div key={label} className="flex flex-1 flex-col items-center gap-1 rounded-lg border border-slate-700 bg-slate-800/40 py-2 text-slate-300">
              <Icon className="h-4 w-4 text-blue-400" />
              <span className="text-[10px] font-medium">{label}</span>
            </div>
          ))}
        </div>

        {/* recent reviews */}
        <div className="space-y-3 px-5 py-4">
          <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Recent reviews</p>
          {reviews.map((r) => (
            <div key={r.initials} className="flex gap-3">
              <div className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-gradient-to-br from-blue-500 to-violet-500 text-[11px] font-bold text-white">
                {r.initials}
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-bold text-white">{r.name}</span>
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} className="h-2.5 w-2.5 fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                </div>
                <p className="mt-0.5 text-xs leading-snug text-slate-400">{r.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <p className="mt-3 px-4 text-center text-xs text-slate-400">
        Every finished job auto-requests a review. Trust compounds.
      </p>
    </div>
  );
};

export default ReviewsMockup;
